import React, { FC, useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
} from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterChipsStatic from '../filters/FilterChipsStatic';
import { trackAction } from '../../services/analytics/AnalyticsService';
import ApiRoutes from '../../services/ApiRoutes';
import API from '../../services/ApiInstance';
import { Filter, SetFilters } from '../../signals/filterService';
import { FilterConfigDto } from '../../api/apiDtos';

interface Props {
  searches: any;
  onDelete: Function;
}

const SavedSearchCard: FC<Props> = ({ searches, onDelete }) => {
  const [filterSettings, setFilterSettings] = useState([]);

  const loadFilterSettings = async () => {
    const response = await API.get<any, FilterConfigDto>(
      ApiRoutes.getOwnFilterConfig
    );
    const filterConfig = response;
    if (filterConfig) {
      const filterSettings = filterConfig.sections.reduce(
        (settings, section) => {
          settings.push(...section.settings);
          return settings;
        },
        []
      );
      setFilterSettings(filterSettings);
    }
  };

  const getFilterSetting = (filterTag) =>
    filterSettings.find((s) => s.typeCode === filterTag);

  const convert = () => {
    return searches.map((s) => {
      const filters: Filter[] = [];
      s.searchFilters.forEach((f) => {
        if (f.selectValue) {
          Object.keys(f.selectValue).forEach((id) => {
            const name = f.selectValue[id];
            filters.push({ name, property: f.property, value: id });
          });
        } else {
          const filterSetting = getFilterSetting(f.property);
          const name = filterSetting ? filterSetting.title : f.textValue;
          filters.push({ name, property: f.property, value: f.textValue });
        }
      });
      return { id: s.id, filters };
    });
  };

  const ApplySavedSearch = (filters: Filter[]) => {
    SetFilters(filters);
    trackAction('saved search', 'run');
  };

  useEffect(() => {
    loadFilterSettings();
  }, []);

  const convertedSearches = convert();

  return (
    <div style={{ minHeight: 400 }}>
      <Table>
        <TableBody>
          {convertedSearches.map((s: any) => (
            <TableRow key={s.id}>
              <TableCell style={{ padding: '6px 0' }}>
                <FilterChipsStatic
                  onMoreClick={() => {}}
                  filters={s.filters}
                />
              </TableCell>
              <TableCell style={{ padding: '6px 0', width: 48 }}>
                <Button
                  size="small"
                  onClick={() => onDelete(s)}
                  style={{ minWidth: 36, color: '#6b7280' }}
                >
                  <DeleteIcon fontSize="small" />
                </Button>
              </TableCell>
              <TableCell style={{ padding: '6px 0', width: 80 }}>
                <Button
                  size="small"
                  onClick={() => ApplySavedSearch(s.filters)}
                  style={{ borderRadius: 8, textTransform: 'none', color: '#df6d2e' }}
                >
                  Run <PlayArrowIcon fontSize="small" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SavedSearchCard;
